<template>
  <Form :model="form" label-position="top">
    <FormItem
      class="cc-form-item"
      label="模板名称"
      style="width: 430px"
      required
    >
      <Input
        class="height60"
        v-model="form.templateName"
        placeholder="请输入模板名称"
        clearable
      ></Input>
    </FormItem>
    <FormItem class="cc-form-item" label="模板类型" required>
      <RadioGroup v-model="form.templateType">
        <Radio :label="0"> 个人</Radio>
        <Radio :label="1"> 企业</Radio>
      </RadioGroup>
    </FormItem>
    <template v-if="form.templateType == 1">
      <FormItem class="cc-form-item" label="企业名称（中文）" required>
        <div class="row">
          <Select
            class="height60"
            v-model="form.enterpriseCertificateId"
            style="width: 430px"
            label-in-value
            @on-change="onEnterpriseCertificateChange"
          >
            <Option
              v-for="item in englishCertified"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button
            class="btn-height45"
            style="margin-left: 20px"
            to="/user/account/myEnterprise"
            >+ 企业认证</Button
          >
        </div>
      </FormItem>
      <FormItem
        class="cc-form-item"
        label="企业名称（英文）"
        style="width: 430px"
        required
      >
        <Input
          class="height60"
          v-model="form.englishBusinessName"
          disabled
          placeholder="请输入企业名称（英文）"
          clearable
        ></Input>
      </FormItem>
    </template>
    <FormItem class="cc-form-item" label="姓名（中文）" required>
      <div class="row">
        <Select
          class="height60"
          v-model="form.idCard"
          style="width: 430px"
          label-in-value
          @on-change="onNameCertifiedChange"
        >
          <Option
            v-for="item in nameCertified"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Button
          class="btn-height45"
          style="margin-left: 20px"
          to="/user/account/myPersonal"
          >+ 身份认证</Button
        >
      </div>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="姓名（英文）"
      style="width: 430px"
      required
    >
      <Input
        class="height60"
        v-model="form.englishName"
        disabled
        placeholder="请输入姓名（英文）"
        clearable
      ></Input>
    </FormItem>
    <FormItem class="cc-form-item" label="邮箱" required>
      <div class="row">
        <Select
          class="height60"
          v-model="form.emailId"
          style="width: 430px"
          label-in-value
          @on-change="onEmailChange"
        >
          <Option
            v-for="item in emailCertified"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Button
          class="btn-height45"
          style="margin-left: 20px"
          to="/user/account/myEmail"
          >+ 邮箱认证</Button
        >
      </div>
    </FormItem>
    <FormItem class="cc-form-item" label="国家" required>
      <Select
        class="height60"
        v-model="form.countryCode"
        style="width: 430px"
        :label-in-value="true"
        @on-change="changeCountry"
      >
        <Option
          v-for="item in countries"
          :key="item.id"
          :value="item.countryShortName"
          >{{ item.countryNameCn }}</Option
        >
      </Select>
    </FormItem>
    <FormItem
      v-if="form.countryCode == 'CN'"
      class="cc-form-item"
      label="省份 城市"
      required
    >
      <div class="row">
        <Select
          class="height60"
          v-model="form.province"
          filterable
          style="margin-right: 10px; width: 120px"
          @on-change="changeProvince"
        >
          <Option
            v-for="(item, index) in areas"
            :key="'p' + index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          class="height60"
          v-if="form.province != null && form.province != ''"
          v-model="form.city"
          style="margin-right: 10px; width: 120px"
          filterable
          @on-change="changeCity"
        >
          <Option
            v-for="item in cityList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          class="height60"
          v-if="
            form.province != null &&
            form.province != '' &&
            form.city != null &&
            form.city != ''
          "
          v-model="form.street"
          filterable
          style="width: 120px"
        >
          <Option
            v-for="item in areaList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="联系地址"
      style="width: 430px"
      required
    >
      <Input
        class="height60"
        v-model="form.street2"
        placeholder="请输入联系地址"
        clearable
      ></Input>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="邮政编码"
      style="width: 430px"
      required
    >
      <Input
        class="height60"
        v-model="form.postcode"
        placeholder="请输入邮政编码"
        clearable
      ></Input>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="联系手机号码"
      style="width: 430px"
      required
    >
      <Input
        class="height60"
        v-model="form.phone"
        placeholder="请输入联系手机号码"
        maxlength="11"
        @on-keyup="form.phone = form.phone.replace(/[^\d]/g, '')"
        clearable
      >
        <div slot="prefix" style="line-height: 60px" v-show="form.phoneCode">
          +{{ form.phoneCode }}
        </div>
      </Input>
    </FormItem>
    <FormItem
      class="cc-form-item"
      label="传真号码"
      style="width: 430px"
      required
    >
      <Input
        class="height60"
        v-model="form.fax"
        placeholder="请输入传真号码"
        clearable
      >
        <div slot="prefix" style="line-height: 60px" v-show="form.countryCode">
          +{{ form.countryCode }}
        </div>
      </Input>
    </FormItem>
    <Button
      class="btn-height45"
      :loading="loading"
      type="primary"
      @click="onConfirm"
      >确认提交</Button
    >
  </Form>
</template>
<script>
import { getcertifiedInformation, templatesSave } from "api/domain.js";
import { mapState, mapActions, mapMutations } from "vuex";
import { pinyin } from "pinyin-pro";
export default {
  name: "templateAdd",
  data() {
    return {
      form: {
        templateName: "",
        templateType: 0,
        enterpriseCertificateId: null,
        englishBusinessName: "",
        chineseBusinessName: "",
        idCard: null,
        chineseName: "",
        englishName: "",
        email: "",
        emailId: "",
        countryId: "",
        country: "",
        countryCode: "", // 国家代码（传真前缀）
        phoneCode: "", // 电话前缀
        street2: "", // 联系地址
        postcode: "", // 邮编
        phone: "", // 手机号码
        fax: "", // 传真号码
        province: "", // 省
        city: "", // 市
        street: "", // 区
      },
      cityList: [], // 城市数据
      areaList: [], // 地区数据
      nameCertified: [], // 实名认证
      emailCertified: [], // 邮箱认证
      englishCertified: [], // 企业认证
      loading: false, // 请求中
    };
  },
  computed: {
    ...mapState(["countries", "areas"]),
    ...mapState(["templateCopy"]),
  },
  async mounted() {
    this.req_getcertifiedInformation();
    if (this.countries.length === 0) {
      await this.ACT_REGION_LIST();
    }
    if (this.templateCopy.templateName) {
      this.form = this.templateCopy;
      this.form.postcode = this.templateCopy.postCode;
      for (const i in this.areas) {
        if (this.areas[i].value === this.form.province) {
          this.cityList = this.areas[i].children;
          break;
        }
      }
      for (const i in this.cityList) {
        if (this.cityList[i].value === this.form.city) {
          this.areaList = this.cityList[i].children;
          break;
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "accountMyPersonal" &&
      to.name !== "accountMyEmail" &&
      to.name !== "accountMyEnterprise"
    ) {
      this.MUT_DOMAIN_TEMPLATECOPY({
        templateName: "",
      });
    }
    next();
  },
  methods: {
    ...mapActions(["ACT_REGION_LIST"]),
    ...mapMutations(["MUT_DOMAIN_TEMPLATECOPY"]),
    async req_getcertifiedInformation() {
      try {
        const { code, data } = await getcertifiedInformation();
        if (code === 200) {
          this.nameCertified = data.userIdentityList;
          this.englishCertified = data.enterpriseIdentityList;
          this.emailCertified = data.emailList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 国家改变
    changeCountry(val) {
      let data = this.countries.filter((o) => o.countryShortName === val.value);
      this.form.country = data[0].countryNameCn;
      this.form.phoneCode = data[0].countryCode;
    },
    // 省改变
    changeProvince() {
      let selectArray = this.areas.filter(
        (o) => o.value === this.form.province
      );
      this.cityList = selectArray[0].children;
      this.form.city = "";
      this.form.street = "";
    },
    // 城市改变
    changeCity() {
      if (this.form.city) {
        let selectArray = this.cityList.filter(
          (o) => o.value === this.form.city
        );
        this.areaList = selectArray[0].children;
        this.form.street = "";
      }
    },
    // 企业认证发生改变
    onEnterpriseCertificateChange(value) {
      this.form.chineseBusinessName = value.label;
      this.form.englishBusinessName = pinyin(value.label, { toneType: "none" });
    },
    // 个人认证发生改变
    onNameCertifiedChange(value) {
      console.log(value);
      this.form.chineseName = value.label;
      this.form.englishName = pinyin(value.label, { toneType: "none" });
    },
    // 邮箱
    onEmailChange(value) {
      this.form.email = value.label;
    },
    // 提交
    async onConfirm() {
      try {
        if (!this.form.templateName) {
          this.$Message.warning("请输入模板名称！");
          return;
        }
        if (!this.form.templateType == null) {
          this.$Message.warning("请选择模板类型！");
          return;
        }
        if (this.form.templateType === 1) {
          if (!this.form.chineseBusinessName) {
            this.$Message.warning("请选择企业名称（中文）！");
            return;
          }
          if (!this.form.englishBusinessName) {
            this.$Message.warning("请输入企业名称（英文）！");
            return;
          }
        }
        if (!this.form.chineseName) {
          this.$Message.warning("请选择姓名（中文）！");
          return;
        }
        if (!this.form.englishName) {
          this.$Message.warning("请输入姓名（英文）！");
          return;
        }
        if (!this.form.emailId) {
          this.$Message.warning("请选择邮箱！");
          return;
        }
        if (!this.form.country) {
          this.$Message.warning("请选择国家！");
          return;
        }
        if (this.form.countryCode === "CN") {
          if (!this.form.province || !this.form.city || !this.form.street) {
            this.$Message.warning("请选择省份-城市！");
            return;
          }
        }
        if (!this.form.street2) {
          this.$Message.warning("请输入联系地址！");
          return;
        }
        if (!this.form.postcode) {
          this.$Message.warning("请输入邮政编码！");
          return;
        }
        if (!this.form.phone) {
          this.$Message.warning("请输入联系电话！");
          return;
        }
        if (!this.form.fax) {
          this.$Message.warning("请输入传真号码！");
          return;
        }
        this.loading = true;
        let params = {
          templateName: this.form.templateName,
          templateType: this.form.templateType,
          chineseName: this.form.chineseName,
          englishName: this.form.englishName,
          idCard: this.form.idCard,
          email: this.form.email,
          emailId: this.form.emailId,
          country: this.form.country,
          countryCode: this.form.countryCode,
          street2: this.form.street2,
          fax: this.form.fax,
          postcode: this.form.postcode,
          phone: this.form.phone,
          phoneCode: this.form.phoneCode,
        };
        if (this.form.templateType === 1) {
          params.enterpriseCertificateId = this.form.enterpriseCertificateId;
          params.englishBusinessName = this.form.englishBusinessName;
          params.chineseBusinessName = this.form.chineseBusinessName;
        }
        if (this.form.countryCode == "CN") {
          params.province = this.form.province;
          params.city = this.form.city;
          params.street = this.form.street;
        }
        const { code, result } = await templatesSave(params);
        if (code === 200 && result) {
          this.$Message.success("添加成功！");
          this.form = this.$options.data().form;
          this.$router.replace("/user/template");
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.cc-form-item {
  .ivu-form-item-label {
    padding-bottom: 20px;
  }
}
/deep/.height60 {
  .ivu-input {
    height: 60px;
    line-height: 60px;
  }
  .ivu-input-disabled {
    background-color: #fff;
    color: #515a6e;
  }
  .ivu-input-icon {
    line-height: 60px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 60px;
  }
  .ivu-select-input {
    height: 60px;
  }
  .ivu-select-selected-value {
    height: 60px;
    line-height: 60px;
  }
  .ivu-select-placeholder {
    height: 60px;
    line-height: 60px;
  }
}

.row {
  display: flex;
  align-items: center;
  .slot {
    cursor: pointer;
    margin-left: 20px;
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
